import { styled } from '@mui/material/styles';
import { Box, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Button } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: theme.spacing(3),
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#333',
}));

export const ExportButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '6px',
  backgroundColor: '#E6F0EA', // Light greenish-grey
  color: '#4A7A6A', // Darker green text
  fontWeight: 600,
  padding: '6px 16px',
  '&:hover': {
    backgroundColor: '#D9E8DF',
  }
}));

export const Title = styled('h2')(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 600,
  color: '#1a1a1a',
  margin: 0,
}));

export const SearchField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#fff',
    borderRadius: '8px',
    '& fieldset': {
      borderColor: '#E0E0E0',
    },
    '&:hover fieldset': {
      borderColor: '#BDBDBD',
    },
  },
  minWidth: '300px',
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  boxShadow: 'none',
  border: '1px solid #E0E0E0',
  borderRadius: '8px',
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& th': {
    backgroundColor: '#5E8E7E', // Theme color from screenshot (greenish)
    color: '#fff',
    fontWeight: 600,
    fontSize: '14px',
    borderBottom: 'none',
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#F9FAFB',
  },
  '&:hover': {
    backgroundColor: '#F3F4F6',
  },
  // Hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.secondary,
  padding: '16px',
}));

export const PaginationFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));
